import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { IconTextWrapper, IconWrapper, TextLabelWrapper, TextValueWrapper, WrapperWithBorder } from '../subcomponents';
var ExecuteAmount = function (_a) {
    var icon = _a.icon, currentBalance = _a.currentBalance;
    var t = useTranslation().t;
    var positiveAmount = currentBalance.slice(1);
    return (_jsxs(WrapperWithBorder, { children: [_jsxs(IconTextWrapper, { children: [_jsx(IconWrapper, { children: icon }), _jsx(TextLabelWrapper, { children: t('text.amount') })] }), _jsx(TextValueWrapper, { children: "$".concat(positiveAmount) })] }));
};
export default ExecuteAmount;
